import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

import LogoIngealimentos from '../assets/images/logo_ingealimentos.png'
import LogoAndina from '../assets/images/logo_andina.png'

export default function AuthLayout({ children }) {
	return (
		<Container>
			<Row>
				<Col>
					<img src={LogoIngealimentos} alt="Logo Ingealimentos" width="130px" />
				</Col>
				<Col>
					<img src={LogoAndina} alt="Logo Andina de Servicios" width="120px" />
				</Col>
			</Row>
			<FormContainer>
				{children}
			</FormContainer>
			<p>Desarrollado por{" "}
				<a href="//smart4.com.co" target="_blank" rel="noreferrer">
					Smart4 Solutions
				</a>
				{" | "}
				Versión {process.env.REACT_APP_VERSION}
			</p>
		</Container>
	)
}

const Container = styled.div`
	width: 100%;
	min-height: 100vh;
	background-color: #f7f8f9;	
	display: flex;
  	justify-content: center;
	align-items: center;
	flex-direction: column;
`

const FormContainer = styled.div`
	background-color: #fff;
	padding: 35px;	
	max-width: 450px;
	width: 100%;
	text-align: center;
	margin: 20px auto;
`